// extracted by mini-css-extract-plugin
export default {"DashMiniSidebar_mini-sidebar":"DashMiniSidebar_mini-sidebar294OmriJl8LF"};